import { createSelector } from '@ngrx/store';
import { getNewsState } from './news-base.selectors';

export const getNewsList = createSelector(getNewsState, (state) => state?.list);
